import React from 'react'
import AccordionHeader from 'components/accordion/StickyHeader'
import HamburgerContainer from 'redux/containers/components/layout/HamburgerContainer'
import LogoLinkContainer from 'redux/containers/components/layout/LogoLinkContainer'
import SearchContainer from 'redux/containers/components/layout/search/SearchContainer'
import DesktopLinksContainer from 'redux/containers/components/layout/DesktopLinksContainer'
import MenuContainer from 'redux/containers/components/layout/MenuContainer'
import HeaderAppendProxyContainer from 'redux/containers/components/layout/HeaderAppendProxyContainer'
import { useSelector } from 'react-redux'
import selectUrl from 'redux/selectors/selectUrl'

const Header = ({
  header: append,
  query,
  searchType,
  params,
  isNavigationVisible,
  isDesktopNavigationVisible,
  isSearchBarVisible
}) => (
  <div className='shadow-black-2' id='application-header'>
    <div className='pt6 pb3 pb2-m pt5-m'>
      <div className='flex justify-between items-center layout-width-constraint'>
        <LogoLinkContainer className='flex grow-0 shrink-0 justify-start items-center mr7 mr6-m' />
        {isSearchBarVisible && (
          <SearchContainer
            className='basis-auto-t grow-5 shrink-1 justify-start relative mr6 mr3-m'
            {...{ query, params }}
          />
        )}
        <HamburgerContainer {...{ isNavigationVisible }} />
        <DesktopLinksContainer className='dn-t flex justify-end items-center grow-0 shrink-0' {...{ params }} />
      </div>
      {isDesktopNavigationVisible && <MenuContainer />}
      <HeaderAppend {...{ append, searchType }} />
      <AccordionHeader />
    </div>
  </div>
)

const HeaderAppend = ({ append, searchType }) => {
  const url = useSelector(selectUrl)

  return append || <HeaderAppendProxyContainer {...{ searchType, url }} />
}

export default Header
